import axiosInstance from "auth/FetchInterceptor";
import { 
  GET_ALL_WORKING_AREA, 
  WORKING_AREA_API, 
  WORKING_AREA_SUMMARY,
  GET_ALL_ACTIVE_WORKING_AREA  
} from "constants/ApiConstant";

const WorkingAreaSettingService = {};

WorkingAreaSettingService.getAreaSummary = function () {
    return axiosInstance.get(WORKING_AREA_SUMMARY, null);
};

WorkingAreaSettingService.getAreas = function (data) {
    return axiosInstance.post(GET_ALL_WORKING_AREA, data);
};

WorkingAreaSettingService.getActiveAreas = function () {
    return axiosInstance.get(GET_ALL_ACTIVE_WORKING_AREA, null);
};

WorkingAreaSettingService.createArea = function (data) {
    return axiosInstance.post(WORKING_AREA_API, data);
};

WorkingAreaSettingService.updateArea = function (data) {
    return axiosInstance.put(WORKING_AREA_API, data);
};

WorkingAreaSettingService.delArea = function (id) {
    return axiosInstance.delete(`${WORKING_AREA_API}/${id}`, null);
};

export default WorkingAreaSettingService;